export default {
  All: '<<Tất cả>>',
  Summary: '<<Tổng hợp>>',
  AllId: 'All',
  // AllGuid: '1cb6d6f0-1d48-11ed-a597-005056b30259',
  AllGuid: '00000000-0000-0000-0000-000000000000',
  SummaryGuid: '99999999-9999-9999-9999-999999999999',
  AllInt: -1,
  SummaryId: 'Summary',
  // SummaryGuid: '2cb6d6f0-1d48-11ed-a597-005056b30259',
  SummaryInt: -2,
  AllText: 'Tất cả',
  SummaryText: 'Tổng hợp',
  None: '<<Không chọn>>',
  NoneText: 'Không chọn',
  NoneId: 'None',
  NoneInt: -3,
};

